import { IMissingVoucherConsent } from '@nkr/models/index';
import { TableWrapper } from '../styles';
import Row from './row';

interface IProps {
    list: IMissingVoucherConsent[],
    centerId: number
}

const MissingVoucherConsents = (props: IProps) => {
    return (
        <>
            <TableWrapper className='table table-condensed table-striped table-bordered'>
                <thead>
                    <tr>
                        <th>Donor Alias</th>
                        <th>Donation Date</th>
                        <th>Voucher Holders with Missing Consents</th>
                    </tr>
                </thead>
                <tbody>
                    {props.list.map((item, index) => {
                        return (
                            <Row
                                key={index}
                                data={item}
                                centerId={props.centerId}
                            />
                        );
                    })}
                </tbody>
            </TableWrapper>
        </>
    );
}

export default MissingVoucherConsents;